const getPushLead = (state: any) =>
  state.getIn(['currentGroup', 'data', 'pushLead']);

export default getPushLead;
